module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "head"
  }, [_c('a', {
    staticClass: "back tl",
    attrs: {
      "href": "javascript:history.back(-1)"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "tc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('small', {
    staticClass: "font_18 co_f"
  }, [_vm._v("评价")])])]), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "comment"
  }, [_c('textarea', {
    attrs: {
      "id": "t",
      "name": "textarea",
      "placeholder": "请输入你的评价.."
    }
  }), _vm._v(" "), _c('button', [_vm._v("提交")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc5adc92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Comment/Comment.vue
// module id = 486
// module chunks = 1